import CloseIcon from '@mui/icons-material/Close'
import { IconButton, useTheme } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { FC, ReactNode } from 'react'

interface Props {
    open: boolean
    title: string
    closeButtonText?: string
    submitButtonText: string
    handleClose: () => void
    handleSubmit: () => void
    isDisabled?: boolean
    colorSubmitButton?: 'primary' | 'secondary' | 'success' | 'error'
    variantCloseButton?: 'outlined' | 'contained'
    children: ReactNode
    isCloseButton?: boolean
    isSubmitButton?: boolean
}

export const ConfirmDialogWrapper: FC<Props> = ({
    open,
    handleClose,
    title,
    closeButtonText = 'Отмена',
    submitButtonText,
    handleSubmit,
    isDisabled,
    colorSubmitButton = 'error',
    variantCloseButton = 'outlined',
    children,
    isSubmitButton = true,
    isCloseButton = true,
}) => {
    const { breakpoints } = useTheme()

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            slotProps={{
                paper: {
                    style: {
                        width: '500px',
                    },
                },
            }}>
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '0',
                    [breakpoints.down('sm')]: {
                        p: 2.5,
                    },
                }}>
                {title}
                <IconButton
                    onClick={handleClose}
                    sx={{
                        border: '1px solid #E9EAED',
                    }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent
                sx={{
                    [breakpoints.down('sm')]: {
                        p: 2.5,
                    },
                }}>
                <DialogContentText sx={{ color: '#5A5F72' }}>{children}</DialogContentText>
            </DialogContent>

            {(isCloseButton || isSubmitButton) && (
                <DialogActions
                    sx={{
                        [breakpoints.down('sm')]: {
                            flexDirection: 'column-reverse',
                            gap: 1,
                            p: 3,
                            pt: 2,
                            alignItems: 'center',
                            '&& > button': {
                                ml: 0,
                            },
                        },
                    }}>
                    {isCloseButton && (
                        <Button
                            fullWidth
                            onClick={handleClose}
                            variant={variantCloseButton}
                            color="primary"
                            disabled={isDisabled}>
                            {closeButtonText}
                        </Button>
                    )}
                    {isSubmitButton && (
                        <Button
                            fullWidth
                            onClick={handleSubmit}
                            color={colorSubmitButton}
                            variant={colorSubmitButton === 'error' ? 'outlined' : 'contained'}
                            disabled={isDisabled}>
                            {submitButtonText}
                        </Button>
                    )}
                </DialogActions>
            )}
        </Dialog>
    )
}
